/**
 * 统一面试页路由判定：仅 path，不认 query.token。
 * @param {string} path 路由 path，如 /store/interview_ing
 */

export function isStoreMemberInterviewPath(path) {
  const p = path || ''
  return /\/store\/interview_ing(?:\/|$)/.test(p) && !/\/store\/interview_ing_by_b/.test(p)
}

export function isStoreTokenInterviewPath(path) {
  return /\/store\/interview_ing_by_b(?:\/|$)/.test(path || '')
}

/** 是否需要在进入前做 interviewState 清理（仅正式 store 子路径；旧 /interview_ing 重定向由第二次导航处理） */
export function shouldPrepareInterviewStateForPath(path) {
  return isStoreMemberInterviewPath(path) || isStoreTokenInterviewPath(path)
}
